module.exports = require("stream-chat-react/dist/css/index.css");